// extracted by mini-css-extract-plugin
module.exports = {"category":"X_d2","wrapp":"X_d3","category__wrapper":"X_d4"};